import { useAuthenticationState } from "@/hooks/useAuthenticationState/useAuthenticationState";
import { useFeatureFlags } from "@/providers/FeatureFlagProvider/FeatureFlagProvider";
import { RestrictedAccessScreen } from "@dashboard/library";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export function RestrictAccess({ children }: PropsWithChildren) {
  const { t } = useTranslation();

  const {
    authState: { isConnectedAs },
  } = useAuthenticationState();

  const { dashboardExtensionEnableRestrictedCompaniesAssetsPage } =
    useFeatureFlags();

  // Allow users that are in some specific companies to access the assets page.
  if (dashboardExtensionEnableRestrictedCompaniesAssetsPage) {
    return children;
  }

  if (isConnectedAs) {
    return (
      <RestrictedAccessScreen
        data-test="restricted-area-message"
        title={t("permissions.unauthorized_screen.title")}
        subtitle={t("permissions.unauthorized_screen.sub_title")}
      />
    );
  }

  return children;
}
